export default "__VITE_ASSET__B84Tm$9H__"